import api from "./axios";
import type { Player } from "@/types";
import { paths } from "./paths";

export const getPlayers = (includeDeleted = false) =>
  api
    .get<Player[]>(paths.players.list, {
      params: includeDeleted ? { includeDeleted: "true" } : {},
    })
    .then((r) => r.data);

export const getPlayer = (id: string) =>
  api.get<Player>(paths.players.one(id)).then((r) => r.data);

export const createPlayer = (data: {
  name: string;
  defense: number;
  agility: number;
  technique: number;
}) => api.post<Player>(paths.players.list, data).then((r) => r.data);

export const updatePlayer = (
  id: string,
  data: {
    name?: string;
    defense?: number;
    agility?: number;
    technique?: number;
  },
) => api.patch<Player>(paths.players.one(id), data).then((r) => r.data);

export const deletePlayer = (id: string) =>
  api.delete(paths.players.one(id)).then((r) => r.data);

export const updateBonusPoints = (id: string, bonusPoints: number) =>
  api
    .patch<Player>(paths.players.bonus(id), { bonusPoints })
    .then((r) => r.data);
